import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { CustomView as FundraisingCustomView } from '../../pages/scenario-modeling/scenario-cap-table/fundraising/fundraising.types';
import { CustomView as LiquidityCustomView } from '../../pages/scenario-modeling/scenario-cap-table/liquidity/liquidity.types';
import { useScenarioStore } from '../../pages/scenario-modeling/scenario-modeling.store';
import { ApiService } from '../../services/index';
import { ScenarioType } from '../../types/scenario-modeling.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useExport = <T extends ScenarioType = ScenarioType.FUNDRAISING>() => {
  const { scenarioId } = useScenarioStore();
  const { mutate: mutateExport, isPending } = useAppMutation(
    [QueryKey.SCENARIO_EXPORT, scenarioId],
    {
      mutationFn: async ({
        body,
      }: {
        body: T extends ScenarioType.FUNDRAISING ? FundraisingCustomView : LiquidityCustomView;
      }) => {
        await ApiService.downloadFile(
          {
            endpoint: BackendRoute.SCENARIOS,
            routePath: [scenarioId, 'cap-table', 'export'],
          },
          { body },
        );
      },
    },
  );

  return { mutateExport, isPending };
};
